import React from 'react';
import { ThemeProvider as MUIThemeProvider, Theme } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { useTheme } from '../contexts/ThemeContext';
import { createAppTheme } from './themeConfig';

export const AppThemeProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { darkMode } = useTheme();

  // Create the theme based on current mode
  const theme: Theme = React.useMemo(
    () => createAppTheme(darkMode ? 'dark' : 'light'),
    [darkMode]
  );

  return (
    <MUIThemeProvider theme={theme}>
      {/* CssBaseline provides consistent baseline styles */}
      <CssBaseline />
      {children}
    </MUIThemeProvider>
  );
};
